// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z1jG","col":"styles_col__3tGyk"};